import React, { useContext, useLayoutEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import PageCounter from "../pages/counter";
import styles from "../styles/EventManagerLayout.module.scss";
import EventNavbar from "../components/EventNavigationBar";
import { Axios } from "../App";
import { UserContext } from '../context/UserContext';
import TitleWithBack from "../components/titleWithBack";

type TEventDesign = {
  name: string;
  logo: string;
  background_color: string;
  font_color: string;
};

const EventManagerPublicLayout = (): JSX.Element => {
  const {user} = useContext(UserContext);  
  const { id } = useParams();
  const navigate = useNavigate();
  const [eventDesign, setEventDesign] = useState<TEventDesign>();

  const isEventExists = async () => {
    try {
      const { data } = await Axios.post("events/isEventExists.php", {
        id: id,
      });
      if (!data?.isExists) navigate("/");
    } catch (e) {
      console.error(e);
    }
  };

  const getEventData = async () => {
    return await Axios.post("events/getEventData.php", { id: id }).then(
      ({ data }) => {
        setEventDesign(data);
      }
    );
  };

  useLayoutEffect(() => {
    const getQueries = async () => {
      await isEventExists();
      await getEventData();
    };

    getQueries();
  }, []);

  return (
    <section style={{ backgroundColor: eventDesign?.background_color
      ? eventDesign?.background_color
      : "#0A1929", minHeight:"100vh" }}>
        {user && <EventNavbar />}
      <div className={styles.layoutInnerWrapper}>
        {user && 
          <Link to={`/${id}/event-manager`}>
            {'<< Vissza a táblázathoz'}
          </Link>
        }
        <TitleWithBack title={eventDesign?.name} fontColor={eventDesign?.font_color} />
        <PageCounter fontColor={eventDesign?.font_color} />
      </div>
    </section>
  );
};

export default React.memo(EventManagerPublicLayout);
